
import { Injectable } from "@angular/core";
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { UserMessagesService } from "../user-messages/user-messages.service";
import { AdminService } from "app/admin/admin.service";
import { promise } from "protractor";
import { ResultOfOperation } from "../model/result-of-operation.model";
import { Observable } from "rxjs";


@Injectable({
    providedIn: "root"
})
export class AdminCanActivateGuard implements CanActivate
{
    private ms_zehut: string;
    isCanActivate: boolean = false;
    constructor(
        private userMessagesService: UserMessagesService,
        private adminService: AdminService,
        private router: Router
    ){}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean>
    {
        // debugger;
        // this.ms_zehut = JSON.parse(localStorage.getItem('ms_zehut_mazmin'));
        // this.adminService.checkIsAdmin().subscribe(res=>{
        //     debugger;
        //     this.isCanActivate = true;
           
        // },error=>{
        //     debugger;
        //     this.isCanActivate = false;   
        //     this.router.navigateByUrl("/kuku");
            
        // });
        // return this.isCanActivate;

        this.ms_zehut = JSON.parse(localStorage.getItem('ms_zehut_mazmin'));
        return this.adminService.checkIsAdmin().map((respone: ResultOfOperation<object>) => {
            return respone.isSuccess;
        }).catch(error => {
            return Observable.of(false);
        });
    }
}